import React, { Component } from 'react';
import $ from 'jquery';
import { login_check } from './Common';

class SecQuizPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      correctText: '정답입니다!',
    };
  }

  async componentDidMount() {
    const isLogin = await login_check();

    if (isLogin) {
      this.setState({ correctText: '정답! 10 Exp 획득!' });
    } else {
      // 원하면 비로그인 문구도 분기 가능
      this.setState({ correctText: '정답입니다!' });
    }
  }
 
  render() {
    const { correctText } = this.state;

    return (
      <>
        <aside className="popup" id="popup--quizPass">
          <div className="popup__wrap">
            <div className="popup__head">
              <button type="button" className="popup__close">
                <span className="sr-only">닫기</span>
              </button>
            </div>

            <i className="ico"> 🎉 </i>
            <p className="tit">정답! 10 Exp 획득!</p>
            <p className="txt">혹시 시사용어 전문가?</p>
          </div>
        </aside>
        <aside className="popup" id="popup--quizPassNoExp">
          <div className="popup__wrap">
            <div className="popup__head">
              <button type="button" className="popup__close">
                <span className="sr-only">닫기</span>
              </button>
            </div>

            <i className="ico"> 🎉 </i>
            <p className="tit">정답입니다!</p>
            <p className="txt">혹시 시사용어 전문가?</p>
          </div>
        </aside>      
      </>
    );
  }
}

export default SecQuizPopup;      